import { render, staticRenderFns } from "./fixpassword.vue?vue&type=template&id=7985527d&scoped=true"
import script from "./fixpassword.vue?vue&type=script&lang=js"
export * from "./fixpassword.vue?vue&type=script&lang=js"
import style0 from "./fixpassword.vue?vue&type=style&index=0&id=7985527d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7985527d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7985527d')) {
      api.createRecord('7985527d', component.options)
    } else {
      api.reload('7985527d', component.options)
    }
    module.hot.accept("./fixpassword.vue?vue&type=template&id=7985527d&scoped=true", function () {
      api.rerender('7985527d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fixpassword/fixpassword.vue"
export default component.exports